import { Component, inject, OnInit } from '@angular/core';
import { PageHeaderComponent } from '@/components/shared/page-header/page-header.component';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DacScenarioService } from '../dac-scenarios.service';
import { DacScenariosRepository } from '@/store/dac-scenarios-state/dac-scenarios-state.repository';
import { PassingModeService } from '../../passing-mode/passing-mode.service';
import { DynamicForm, SelectOption } from '@/components/form-builder/form-builder.types';
import { inspectDacScenariosFormObject } from './utils/inspect-dac-scenarios-form-object';
import { MessageService } from 'primeng/api';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { ScenarioEtape } from '@/types/scenarios.types';
import { DataTableBuilderComponent } from '@/components/data-table-builder/data-table-builder.component';
import { DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { getInspectStepsDataTableStructure } from './utils/inspect-steps-data-table-object';

@Component({
  selector: 'sm-inspect-dac-scenarios',
  imports: [PageHeaderComponent, FormBuilderComponent, TranslateModule, DataTableBuilderComponent],
  templateUrl: './inspect-dac-scenarios.component.html',
  styleUrl: './inspect-dac-scenarios.component.scss',
})
export class InspectDacScenariosComponent implements OnInit {
  dacScenarioService = inject(DacScenarioService);
  dacScenariosRepository = inject(DacScenariosRepository);
  messageService = inject(MessageService);
  translate = inject(TranslateService);
  activatedRoute = inject(ActivatedRoute);
  modePassationService = inject(PassingModeService);

  breadcrumb = [
    {
      label: 'settings.dacScenarios.breadcrumb.parametres',
      routerLink: ['/settings'],
    },
    {
      label: 'settings.dacScenarios.breadcrumb.scenarios',
      routerLink: ['/settings', 'dac-scenarios'],
    },
    {
      label: 'settings.dacScenarios.inspect.title',
      routerLink: ['/settings', 'dac-scenarios', 'inspect'],
    },
  ];

  modePassationOptions?: SelectOption[];

  formObject: DynamicForm = inspectDacScenariosFormObject({
    store: this.dacScenariosRepository,
  });

  dataTableObject: DynamicDataTable = getInspectStepsDataTableStructure();

  id = this.activatedRoute.snapshot.paramMap.get('id');
  data: ScenarioEtape[] = [];
  loading = false;

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.loading = true;
    if (this.id) {
      this.dacScenarioService.getOne(+this.id).subscribe({
        next: response => {
          this.dacScenariosRepository.set('dto', {
            modePassationIds: response.modePassations.map(mode => mode.id),
            nom: response.nom,
            description: response.description,
            code: response.code,
          });
          this.dacScenariosRepository.set('response', response);
          this.data = response.scenarioEtapes;
          this.loading = false;
          this.loadModePassationOptions();
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: this.translate.instant('settings.dacScenarios.message.error.loading'),
          });
        },
      });
    }
  }

  private loadModePassationOptions() {
    this.modePassationService.list().subscribe(modePassationOptions => {
      this.modePassationOptions = (modePassationOptions || []).map(modePassation => ({
        name: modePassation.libelle,
        code: Number(modePassation.id),
      }));

      this.dacScenariosRepository.set(
        'passingModeSelected',
        this.modePassationOptions.filter(option =>
          (this.dacScenariosRepository.getNested<number[]>('dto', 'modePassationIds') || []).includes(option.code as number)
        )
      );

      this.formObject = inspectDacScenariosFormObject({
        store: this.dacScenariosRepository,
        passingModeOptions: this.modePassationOptions,
      });
    });
  }
}
